import { Injectable } from '@angular/core'

import { ImageValidatorService } from './../core/image-validator/image-validator.service'

import { AvatarSizeService } from './avatar-size.service'
import { AvatarData } from './avatar-data'

@Injectable({providedIn: 'root'})
export class AvatarService {

  constructor(private avatarSizeService: AvatarSizeService,
              private imageValidatorService: ImageValidatorService) {
    // noop
  }

  public async getData(size?: string, border?: boolean, imageUrl?: string, hasIcon?: boolean): Promise<AvatarData> {

    this.initAvatarSizes()
    const hasImage = await this.imageValidatorService.isValidImage(imageUrl)

    return {
      componentClass: this.getComponentClass(size, border, hasImage, hasIcon),
      componentStyle: (hasImage) ? {'background-image': `url('${imageUrl}')`} : undefined,
      hasImage: hasImage
    }

  }

  private getComponentClass(size?: string, border?: boolean, hasImage?: boolean, hasIcon?: boolean): string {

    let avatarClass = 'se-avatar'

    size = this.getSize(size)
    avatarClass += `--${size}`

    if (border) {
      avatarClass += '--with-border'
    }

    if (hasImage) {
      avatarClass += '--with-image'
    }

    if (!hasImage && hasIcon) {
      avatarClass += '--with-icon'
    }

    return avatarClass

  }

  private getSize(attributeValue: string): string {
    return (this.avatarSizeService.isValid(attributeValue)) ? attributeValue : this.avatarSizeService.getDefaultSize()
  }

  public getInitials(identity: string, length: number = 2): string {

    if (!identity) {
      return ''
    }

    const indexOfSpace = identity.indexOf(' ')

    if (indexOfSpace === -1 || length === 1) {
      return identity.charAt(0)
    }

    const firstInitial = identity.slice(0, indexOfSpace).charAt(0)
    const lastInitial = identity.slice(indexOfSpace + 1).charAt(0)
    return firstInitial + lastInitial

  }

  public initAvatarSizes(): void {

    if (this.avatarSizeService.validSizes && this.avatarSizeService.validSizes.length > 0) {
      return
    }

    this.avatarSizeService.init()

  }

}
